module.exports = __webpack_public_path__ + "static/media/add-logo-tablet-es.4dfe26d1.webp";